import { getParent, types } from 'mobx-state-tree';

const RoutingStore = types
  .model('RoutingStore', {
    browserHistory: types.frozen,
    routeMainPath: types.optional(types.string, 'dashboard'),
    routeMainPathForBIFM: types.optional(types.string, 'orders'),
  })
  .actions(self => ({
    setRouteMainPath() {
      self.routeMainPath =
        self.browserHistory.getCurrentLocation().pathname.split('/')[1] || 'dashboard';
    },
    setRouteMainPathForBifm() {
      self.routeMainPathForBIFM =
        self.browserHistory.getCurrentLocation().pathname.split('/')[1] || 'orders';
    },
    isCurrentPath(path) {
      return self.browserHistory.getCurrentLocation().pathname === path;
    },
    reloadDiscoverAndList() {
      return getParent(self).discoveryStore.getQList();
    },
    reloadListings() {
      getParent(self).listingsPageStore.fetchAllData();
    },
    reloadOrders() {
      return getParent(self).ordersStore.fetchData();
    },
  }));

export default RoutingStore;
